module.exports = __webpack_public_path__ + "fonts/fa-regular-400.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.ttf
// module id = 51
// module chunks = 0